<template>
  <div
    class="dropdown noselect"
    @click="opened = !opened"
    v-on-clickaway="away"
    :class="[{ 'opened' : opened }]"
  >
    <span
      v-if="icon"
      class="icon"
    >
      <font-awesome-icon :icon="icon" />
    </span>
    <span v-html="label"></span>
    <span
      v-if="caret"
      class="caret"
    >
      <font-awesome-icon :icon="caret" />
    </span>
    <ul class="dropdown-menu">
      <template v-for="(item, index) in items">
        <li
          v-if="typeof item.label !== 'undefined'"
          @click="resolve(item)"
          :key="`dropdown-item-${index}`"
        >
          {{ item.label }}
        </li>
        <li
          v-if="item === 'break'"
          class="break"
          :key="`dropdown-item-${index}`"
        >
          <hr>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [clickaway],
  name: 'Dropdown',
  props: ['label', 'items', 'icon', 'caret'],
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    away() {
      this.opened = false;
    },
    /**
     * Try to resolve what should happen once item is clicked
     */
    resolve(item) {
      if (typeof item.action === 'function') {
        item.action();
      } else if (
        typeof item.name !== 'undefined' &&
        typeof item.params === 'undefined'
      ) {
        this.$router.push({ name: item.name });
      } else if (
        typeof item.name !== 'undefined' &&
        typeof item.params !== 'undefined'
      ) {
        this.$router.push({ name: item.name, params: item.params });
      }
    },
  },
};
</script>

<style lang="scss">
.dropdown {
  position: relative;
  .dropdown-menu {
    transition: all 0.3s;
    transform: translateY(20px);
    text-align: center;
    height: 0;
    overflow: hidden;
    position: absolute;
    top: 100%;
    width: 100%;
    min-width: 150px;
    right: 0;
    z-index: 2;
    margin: 2px 0 0;
    border-radius: $btn-border-radius;
    background-color: #fff;
    list-style-type: none;
    padding-left: 0;
    pointer-events: none;
    box-shadow: none;
    li:not(.break) {
      padding: 1em;
      color: $text;
      z-index: 4;
      position: relative;

      &:hover {
        background-color: $fill-highlight;
      }
    }
    li.break {
      line-height: 0;
      font-size: 0;
      padding: 0;
      hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid darken($fill-highlight, 10%);
        padding: 0;
      }
    }
  }
  &.opened {
    .dropdown-menu {
      pointer-events: all;
      transform: translateY(0);
      box-shadow: $shadow-standard;
      overflow: visible;
      height: auto;
      &:after {
        display: block;
        content: '';
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: #fff;
        z-index: 3;
        transform: rotate(-45deg);
        top: 0;
        left: 50%;
        margin-left: -6px;
        margin-top: -6px;
      }
    }
  }
  .caret {
    padding-left: 20px;
  }
}
</style>

<docs>
Dropdown documentation.

## Examples

Sample dropdown:

```jsx
<Dropdown items="[]" icon="ellipsis-v"></Dropdown>
```

```js
items: [
  {
    label: 'Delete',
    action: () => {
      this.bulk('delete');
    },
  },
]
```
</docs>
